import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/my_company_members/MyCompanyMembersFlyout.scss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import CloseBigIcon from '../../assets/images/close-big-15x15.svg';
import classNames from 'classnames';
import * as _ from 'lodash';
import autobind from 'autobind-decorator';
import { __, setTableParams } from '../../core/utils';
import ArrowDownMiddleIcon from '../../assets/images/arrow-down-middle-15x15.svg';
import { Element, ScrollLink, scrollSpy } from 'react-scroll';
import UserEmploymentTerms from './UserEmploymentTerms';
import Details from './Details';
import PrivateDetails from './PrivateDetails';
import Files from './Files';
import Financial from './Financial';
import AccessRights from './AccessRights';
import { readMyCompanyMemberHistory } from '../../redux/actions/table/my_company_members';
import History from './History';
import EditMyCompanyMemberToolbarForm from './EditMyCompanyMemberToolbarForm';
import Tooltip from '../../components/Tooltip';

const mapStateToProps = (state) => {
  return {
    tab_opened: _.get(state.table, ['my_company_members', 'tab']),
    clicked_row: _.get(state.table, ['my_company_members', 'clicked_row']),
    user_id: state.auth.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.my_company_members/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(mapStateToProps, mapDispatchToProps)
@withRouter
class MyCompanyMembersFlyout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed_tabs: [], //fix for scrollSpy not working on init
      highlighted_tab: null,
      history_expanded: false,
    };

    this.highlight_timeout = null;

    this.tabs = [
      'details',
      'private-details',
      'user-employments',
      'financial',
      'files',
      'access-rights',
      'history',
    ];

    this.tab_refs = [];
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    //handle change flyout my company member ID
    if (
      _.get(prevProps, 'data.details.id') &&
      _.get(this.props, 'data.details.id') &&
      _.get(prevProps, 'data.details.id') !=
        _.get(this.props, 'data.details.id')
    ) {
      this.setState({
        history_expanded: false,
        collapsed_tabs: _.merge(this.state.collapsed_tabs, ['history']),
      });
    }
  }

  componentDidMount() {
    scrollSpy.update();

    this.setState({
      collapsed_tabs: [],
      collapsed_tabs: ['history'],
    });

    if (this.props.tab_opened) {
      setTimeout(() => {
        this.tab_refs[this.props.tab_opened] &&
          this.tab_refs[this.props.tab_opened].click();

        setTableParams('my_company_members', {
          tab: undefined,
        });
      }, 500);
    }
  }

  @autobind
  _lazyLoadTaskHistory() {
    if (!this.state.history_expanded) {
      readMyCompanyMemberHistory(this.props.data?.details?.id);

      this.setState({
        history_expanded: true,
      });
    }
  }

  @autobind
  _toggleCollapseTab(tab) {
    if (tab == 'history') {
      this._lazyLoadTaskHistory();
    }

    this.setState({
      collapsed_tabs: _.xor(this.state.collapsed_tabs, [tab]),
    });
  }

  @autobind
  _highlightSection(section) {
    this.setState({ highlighted_tab: section }, () => {
      if (this.highlight_timeout) clearTimeout(this.highlight_timeout);

      this.highlight_timeout = setTimeout(() => {
        this.setState({ highlighted_tab: null });
      }, 200);
    });
  }

  @autobind
  _toggleCollapseTabs() {
    if (_.size(this.state.collapsed_tabs) == _.size(this.tabs)) {
      this.setState({
        collapsed_tabs: [],
      });
    } else {
      this.setState({
        collapsed_tabs: this.tabs,
      });
    }

    this.refs.scroll.scrollTop = 0;
  }

  render() {
    const { data, readAction, permissions, user_id } = this.props;

    const { collapsed_tabs, highlighted_tab } = this.state;

    const permissionValues = Object.values(permissions || {});

    const isSelf =
      data?.details?.id && user_id && data?.details?.id === user_id;

    const TabLink = ScrollLink((props) => (
      <span
        ref={(ref) => (this.tab_refs[props.target] = ref)}
        onClick={(e) => {
          this.setState({
            collapsed_tabs: _.reject(
              collapsed_tabs,
              (section) => section == props.target
            ),
          });

          props.target == 'history' && this._lazyLoadTaskHistory();

          this._highlightSection(props.target);

          props.onClick(e);
        }}
        className={props.className}
      >
        {props.children}
      </span>
    ));

    const Tab = (props) => (
      <TabLink
        target={props.target}
        activeClass={styles.active}
        to={props.target}
        spy={true}
        smooth={true}
        duration={500}
        container={this.refs.scroll}
      >
        {props.children}
      </TabLink>
    );

    return (
      <div className={styles.preview}>
        <div className={styles.header}>
          <div className={styles.title}>
            <span>
              <strong>{this.props.initialValues?.fullname}</strong>
            </span>
            <CloseBigIcon
              onClick={() =>
                setTimeout(
                  () =>
                    this.props.actions.setTableParams({
                      clicked_row: undefined,
                    }),
                  100
                )
              }
            />
          </div>
          <div className={styles.actions}>
            {/* <div className={styles.actionWrapper}> 
            </div> */}
            {/* <div className={styles.actionWrapper}>
              <Tooltip text={__('my-company-members.tooltip.icon.export-tasks-pdf')}>
                <PrintIcon
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                />
              </Tooltip>
            </div> */}
          </div>
        </div>
        <div className={styles.toolbar}>
          {/* {data?.company_segment_name && (
            <Tooltip text={data?.company_segment_name}>
              <div className={classNames(styles.baloon, styles.set)}>
                {data?.company_segment_name}
              </div>
            </Tooltip>
          )}
          {data?.company_position_name && (
            <Tooltip text={data?.company_position_name}>
              <div className={classNames(styles.baloon, styles.set)}>
                {data?.company_position_name}
              </div>
            </Tooltip>
          )} */}
          <EditMyCompanyMemberToolbarForm
            data={data}
            readAction={readAction}
            // onSubmit={this._handleSubmit}
            initialValues={{
              ..._.pick(data, [
                'id',
                'company_segment_name',
                'company_position_name',
              ]),
              visibility: _.toString(data.visibility),
              status: _.toString(data.status),
            }}
          />
          {data?.company_segment_name && (
            <Tooltip text={data?.company_segment_name}>
              <div className={classNames(styles.baloon, styles.set)}>
                {data?.company_segment_name}
              </div>
            </Tooltip>
          )}
          {data?.company_position_name && (
            <Tooltip text={data?.company_position_name}>
              <div className={classNames(styles.baloon, styles.set)}>
                {data?.company_position_name}
              </div>
            </Tooltip>
          )}
        </div>
        <div className={styles.tabsWrapper}>
          <ArrowDownMiddleIcon
            className={classNames(
              styles.collapseAll,
              _.size(collapsed_tabs) == _.size(this.tabs) && styles.collapsed
            )}
            onClick={this._toggleCollapseTabs}
          />
          <div className={styles.tabs}>
            {(permissionValues.includes('view.user.details') || isSelf) && (
              <Tab target='details'>
                {__('my-company-members.flyout.details')}
              </Tab>
            )}
            {(permissionValues.includes('view.employment.private.details') ||
              isSelf) && (
              <Tab target='private-details'>
                {__('my-company-members.flyout.private-details')}
              </Tab>
            )}
            {permissionValues.includes('view.employment.terms') && (
              <Tab target='user-employments'>
                {__('my-company-members.flyout.user-employments')}
              </Tab>
            )}
            {permissionValues.includes(
              'view.employment.compensation.details'
            ) && (
              <Tab target='financial'>
                {__('my-company-members.flyout.financial')}
              </Tab>
            )}
            <Tab target='files'>{__('my-company-members.flyout.files')}</Tab>
            {permissionValues.includes(
              'view.permissions.in.permission.manager'
            ) && (
              <Tab target='access-rights'>
                {__('my-company-members.flyout.access-rights')}
              </Tab>
            )}
            {permissionValues.includes('view.employment.history') && (
              <Tab target='history'>
                {__('my-company-members.flyout.history')}
              </Tab>
            )}
          </div>
        </div>
        <div className={styles.content} ref='scroll'>
          {(permissionValues.includes('view.user.details') || isSelf) && (
            <Element
              name='details'
              className={classNames(
                styles.section,
                highlighted_tab == 'details' && styles.highlighted
              )}
            >
              <div
                className={styles.title}
                onClick={() => this._toggleCollapseTab('details')}
              >
                <ArrowDownMiddleIcon
                  className={classNames(
                    styles.collapse,
                    _.includes(collapsed_tabs, 'details') && styles.collapsed
                  )}
                />
                {__('my-company-members.flyout.details')}
              </div>
              <Details
                collapsed={_.includes(collapsed_tabs, 'details')}
                data={data}
                readAction={readAction}
              />
            </Element>
          )}
          {(permissionValues.includes('view.employment.private.details') ||
            isSelf) && (
            <Element
              name='private-details'
              className={classNames(
                styles.section,
                highlighted_tab == 'private-details' && styles.highlighted
              )}
            >
              <div
                className={styles.title}
                onClick={() => this._toggleCollapseTab('private-details')}
              >
                <ArrowDownMiddleIcon
                  className={classNames(
                    styles.collapse,
                    _.includes(collapsed_tabs, 'private-details') &&
                      styles.collapsed
                  )}
                />
                {__('my-company-members.flyout.private-details')}
              </div>
              <PrivateDetails
                collapsed={_.includes(collapsed_tabs, 'private-details')}
                data={data}
                readAction={readAction}
              />
            </Element>
          )}
          {permissionValues.includes('view.employment.terms') && (
            <Element
              name='user-employments'
              className={classNames(
                styles.section,
                highlighted_tab == 'user-employments' && styles.highlighted
              )}
            >
              <div
                className={styles.title}
                onClick={() => this._toggleCollapseTab('user-employments')}
              >
                <ArrowDownMiddleIcon
                  className={classNames(
                    styles.collapse,
                    _.includes(collapsed_tabs, 'user-employments') &&
                      styles.collapsed
                  )}
                />
                {__('my-company-members.flyout.user-employments')}
              </div>
              <UserEmploymentTerms
                collapsed={_.includes(collapsed_tabs, 'user-employments')}
                data={data}
                readAction={readAction}
              />
            </Element>
          )}
          {permissionValues.includes(
            'view.employment.compensation.details'
          ) && (
            <Element
              name='financial'
              className={classNames(
                styles.section,
                highlighted_tab == 'financial' && styles.highlighted
              )}
            >
              <div
                className={styles.title}
                onClick={() => this._toggleCollapseTab('financial')}
              >
                <ArrowDownMiddleIcon
                  className={classNames(
                    styles.collapse,
                    _.includes(collapsed_tabs, 'financial') && styles.collapsed
                  )}
                />
                {__('my-company-members.flyout.financial')}
              </div>
              <Financial
                collapsed={_.includes(collapsed_tabs, 'financial')}
                data={data}
                readAction={readAction}
              />
            </Element>
          )}
          <Element
            name='files'
            className={classNames(
              styles.section,
              highlighted_tab == 'files' && styles.highlighted
            )}
          >
            <div
              className={styles.title}
              onClick={() => this._toggleCollapseTab('files')}
            >
              <ArrowDownMiddleIcon
                className={classNames(
                  styles.collapse,
                  _.includes(collapsed_tabs, 'files') && styles.collapsed
                )}
              />
              {__('my-company-members.flyout.files')}
            </div>
            <Files
              collapsed={_.includes(collapsed_tabs, 'files')}
              data={data}
              readAction={readAction}
            />
          </Element>
          {permissionValues.includes(
            'view.permissions.in.permission.manager'
          ) && (
            <Element
              name='access-rights'
              className={classNames(
                styles.section,
                highlighted_tab == 'access-rights' && styles.highlighted
              )}
            >
              <div
                className={styles.title}
                onClick={() => this._toggleCollapseTab('access-rights')}
              >
                <ArrowDownMiddleIcon
                  className={classNames(
                    styles.collapse,
                    _.includes(collapsed_tabs, 'access-rights') &&
                      styles.collapsed
                  )}
                />
                {__('my-company-members.flyout.access-rights')}
              </div>
              <AccessRights
                collapsed={_.includes(collapsed_tabs, 'access-rights')}
                data={data}
                readAction={readAction}
              />
            </Element>
          )}
          {permissionValues.includes('view.employment.history') && (
            <Element
              name='history'
              className={classNames(
                styles.section,
                highlighted_tab == 'history' && styles.highlighted
              )}
            >
              <div
                className={styles.title}
                onClick={() => this._toggleCollapseTab('history')}
              >
                <ArrowDownMiddleIcon
                  className={classNames(
                    styles.collapse,
                    _.includes(collapsed_tabs, 'history') && styles.collapsed
                  )}
                />
                {__('my-company-members.flyout.history')}
              </div>
              <History
                collapsed={_.includes(collapsed_tabs, 'history')}
                data={data}
                readAction={readAction}
              />
            </Element>
          )}
        </div>
      </div>
    );
  }
}

export default MyCompanyMembersFlyout;
